"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledBody = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledBody = styled_components_1.default.tbody `
  display: block;
  border-top: none !important;
  padding-bottom: ${(props) => (props.padding ? props.padding : '0')}px;
`;
